import './EditAdminModal.scss'

import React, {Component} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import ConfirmButton from 'common/views/atoms/ConfirmButton/ConfirmButton'
import FormField from "broker/views/components/common/FormField"
import { editAdminInformation } from "broker/redux/account"
import { changePasswordById } from "common/redux/auth"
import toastr from "toastr"

export class StyledInput extends Component {
  render() {
      let {label, value, onChange} = this.props;
      return (
        <FormField label={label} className="EditAdminModal__col" isRequired>
          <input
            value={value}
            type="text"
            onChange={(evt) => onChange(evt.target.value)}
          />
        </FormField>
      )
    }
  }
  export class PasswordForm extends Component {
      constructor(props) {
        super(props)
        this.state = {
          showPassword: false
        }
      }

      showHide = () => {
        this.setState({
          showPassword: !this.state.showPassword
        })
      }

      render() {
        let { password, passwordOnChange } = this.props
           return (
             <FormField label={"New Password"} className="EditAdminModal__col" isRequired>
               <div className="EditAdminModal__row">
                 <input
                   className="EditAdminModal__styled_input"
                   value={password}
                   type={this.state.showPassword ? "text" : "password" }
                   onChange={(evt) => passwordOnChange(evt.target.value)}>
                 </input>

                 <span className="EditAdminModal__icon" onClick={this.showHide}>
                   {this.state.showPassword ?
                     < i className="fa fa-eye-slash fa-lg"></i>
                     : <i className="fa fa-eye fa-lg"></i>
                   }
                 </span>
               </div>
             </FormField>
           )
      }
  }

  export class ConfirmPasswordForm extends Component {
    constructor(props) {
      super(props)
      this.state = {
        showPassword: false
      }
    }

    showHide = () => {
      this.setState({
        showPassword: !this.state.showPassword
      })
    }

    render() {
      let { confirmPassword, confirmPasswordOnChange } = this.props
         return (
           <FormField label={"Confirm Password"} className="EditAdminModal__col" isRequired>
             <div className="EditAdminModal__row">
               <input
                 className="EditAdminModal__styled_input"
                 value={confirmPassword}
                 type={this.state.showPassword ? "text" : "password" }
                 onChange={(evt) => confirmPasswordOnChange(evt.target.value)}>
               </input>

               <span className="EditAdminModal__icon" onClick={this.showHide}>
                 {this.state.showPassword ?
                   < i className="fa fa-eye-slash fa-lg"></i>
                   : <i className="fa fa-eye fa-lg"></i>
                 }
               </span>
             </div>
           </FormField>
         )
    }
  }

export class ChangePassword extends Component {
  render() {
      let { password, passwordOnChange, confirmPassword, confirmPasswordOnChange, handleCancelPassword } = this.props;
      return (
        <div>
          <div className="EditAdminModal__row">
            <PasswordForm
              password={password}
              passwordOnChange={passwordOnChange}
            />

          </div>
          <div className="EditAdminModal__row">
            <ConfirmPasswordForm
              password={confirmPassword}
              confirmPasswordOnChange={confirmPasswordOnChange}
              />
          </div>
          <div className="EditAdminModal__button_row">
            <Button onClick={handleCancelPassword}>Back</Button>
          </div>
        </div>

      )
    }
  }

class EditAdmin extends Component {
  constructor(props) {
    super(props)
    const brokerUser = props.brokerUser
    this.state = {
      firstName: brokerUser.first_name,
      lastName: brokerUser.last_name,
      email: brokerUser.email,
      brokerUserId: brokerUser.id,
      showPasswordReset: false,
      password: null,
      confirmPassword: null,
      error: null
    }
  }

  handleSubmissionClick = () => {
    this.props.dispatch(
      editAdminInformation(this.state.firstName, this.state.lastName, this.state.email, this.state.brokerUserId)
    ).then(
      this.props.handleHide
    ).then(
      this.props.refresh()
    )
  }

  handleResetPasswordClick = () => {
    this.setState({
      showPasswordReset: !this.state.showPasswordReset,
      password: null,
      confirmPassword: null,
    })
  }

  handlePasswordSubmit() {
    const { brokerUser} = this.props
    if (!this.validatePassword()) {
          return
    }
    this.props.dispatch(changePasswordById(brokerUser.id, this.state.password)).then(
      this.props.handleHide
    ).then(
      this.props.refresh()
    )
  }
  validatePassword() {
      if (this.state.password != this.state.confirmPassword) {
        toastr.error("Passwords do not match")
        this.setState({error: "Passwords do not match"})
        return false
      }
      if (this.state.password.length < 6) {
        toastr.error("Password must be at least 6 characters")
        this.setState({error: "Password must be at least 6 characters"})
        return false
      }
      this.setState({error: null})
      return true
    }

  render() {
    const { user } = this.props
    const showPasswordResetEdit = user.is_masquerade && this.state.showPasswordReset

    return (
      <Modal className="EditAdminModal" show={this.props.show}>
        <Modal.Header>
          <Modal.Title>Edit Admin</Modal.Title>
        </Modal.Header>

        <Modal.Body className="EditAdminModal">
          {!showPasswordResetEdit &&
            <div>
              <div className="EditAdminModal__row">
                <StyledInput label={"First Name"} value={this.state.firstName}  onChange={(val) => this.setState({firstName: val})} />
                <StyledInput label={"Last Name"} value={this.state.lastName} onChange={(val) => this.setState({lastName: val})}/>
              </div>
              <div className="EditAdminModal__row">
                <StyledInput label={"Email"} value={this.state.email} onChange={(val) => this.setState({email: val})}/>
              </div>
            </div>
          }
          {user.is_masquerade && (!showPasswordResetEdit ?
            <Button className="pull-left" onClick={this.handleResetPasswordClick}>Reset Password</Button>
            :
            <ChangePassword
              password={this.state.password}
              confirmPassword={this.state.confirmPassword}
              passwordOnChange={(val) => this.setState({password: val})}
              confirmPasswordOnChange={(val) => this.setState({confirmPassword: val})}
              handleCancelPassword={() => this.handleResetPasswordClick()}
            />
          )
          }
        </Modal.Body>

        <Modal.Footer>
          <Button className="pull-left" onClick={this.props.handleHide}>Cancel</Button>
          <div className="pull-right btn-pad-right">
            <ConfirmButton
              onSubmit={() => showPasswordResetEdit ? this.handlePasswordSubmit() : this.handleSubmissionClick()}
              onFinish={this.props.handleHide}
              timeouts={2000}
              initialText="Confirm Changes"
             />
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const EditAdminModal = connectModal({ name: 'EditAdminModal', destroyOnHide: true })(EditAdmin)
export default EditAdminModal
